@if (shouldShow) {
  <div class="home-section m-b-50 new-addition">
    <div class="d-flex align-items-center new-addition-content m-t-10">
      <img [src]="product.imageUrl" [alt]="'home.newProduct.new_product_image' | translate" />
      <div class="m-l-20">
        <span class="c-pink t-14 brandfont-bold">{{ "home.newProduct.new_release" | translate }}</span>
        <h2 class="brandfont-bold">{{ product.title }}</h2>
        @if (description) {
          <div style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden">
            <span [innerHTML]="description"></span>
          </div>
        }
        <br />
        <button role="link" class="btn btn-primary" (click)="viewProduct()">
          {{ "home.newProduct.view_details" | translate }}
          <span class="sr-only">{{ "home.newProduct.go_to_product_page" | translate }}</span>
        </button>
      </div>
    </div>
  </div>
}
